import { ACTION_TYPES, MUTATION_TYPES } from './types';
import { getCurrentAcademicYear as _getCurrentAcademicYear } from '@/services/common/academicyear.api.js';

export default {
  async [ACTION_TYPES.GET_CURRENT_ACADEMIC_YEAR](context) {
    if (context.state.currentAcademicYear == null) {
      const academicYear = await _getCurrentAcademicYear();
      context.commit(MUTATION_TYPES.SET_CURRENT_ACADEMIC_YEAR, academicYear);
      sessionStorage.setItem(
        'current-academic-year',
        JSON.stringify(academicYear)
      );
    }
  },
};
